const editarPrestacionFormState = {
  dupsMsg: "",
  aceptaGuardadoModalEdicion: false,
  aceptaGuardadoModal: false,
  idPrestacion: 0,
  vigenciaPrestacionEdicion: null,
  valorPrestacion: "0",
  valoresPrestaciones: [],
  valoresPrestacionesErr: [],
  valoresAranceles: [],
  valoresIdsArbolAranceles: [],
  centrosAtencionPrestacion: [],
  tiposArancelPrestacion: [],
  tipoUnidadGrilla: [],
  checkTodos: false,
  prestacionesSeleccionadas: [],
  tipoUnidadReplicar: null,
  valorMaxPres: [],
  detallePrestacion: {
    codigoPrestacionPrestador: "",
    pabellonPrestacion: "",
    glosaPrestacionPrestador: "",
    codigoFonasa: "",
    grupoPrestacionIsapre: "",
    grupoPrestacionPrestador: "",
    codigoPrestacionIsapre: "",
    glosaPrestacionIsapre: "",
    codigoProfesional: "",
    montoArancelPrestacion: "",
    montoArancelError: "",
    unidadArancelPrestacion: "",
    inicioVigenciaArancel: "",
    tipoAtencion: "",
    itemImed: "",
    glosagGupoPrestacionIsapre: "",
  },
  inicioVigenciaArancelErr: "",
  loadingArbolDetalle: false,
};

export default editarPrestacionFormState;

